module.exports = __webpack_public_path__ + "static/media/JourneyIcon5.59b9eb9f.png";